/**
 * Worker self-service routes.
 *
 * `/me/profile` is the 6-tab self-service branch of the Worker Info
 * UI (old Haken's "CandidateView"). See
 * `src/features/workers/info/self/page.tsx` for the page and the
 * nav/role gating in `src/layout/AppShell.tsx`.
 */

import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const SelfProfilePage = lazy(
  () => import('@/features/workers/info/self/page')
);

export const meRoutes: RouteObject[] = [
  { path: 'me/profile', element: <SelfProfilePage /> },
];
